import React from 'react';
import * as images from '../../images/logos';
interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function Logo({ width, height, style, className = '' }: LogoProps) {
  const styles = { width, height, display: 'inline-block', ...style };
  return (
    <div
      style={styles}
      className={` ${className} `}
    >
      <img width={36} className="chart-img" src={images.LogoWithoutName} />
    </div>
  );
}
